let promoConnectSyncSuppressedUntil = 0;

function suppressPromoConnectSync(durationMs = 800) {
  promoConnectSyncSuppressedUntil = Date.now() + durationMs;
}

function promotionalItemProperties() {
  return {
    _promotional_item: true,
  };
}

function lineHasPromotionalProperty(item) {
  const value = item?.properties?._promotional_item;
  return value === true || value === 'true';
}

function getEarnedBaseRewardQty(promoData, cart, options = {}) {
  const conditions = [];

  for (let i = 1; i <= 3; i++) {
    if (promoData[`trigger_${i}_enabled`] === false) continue;

    const conditionCollection = promoData[`trigger_${i}_collection`];
    if (!conditionCollection) continue;

    const count = (cart?.items || [])
      .filter((item) => {
        if (lineHasPromotionalProperty(item)) return false;
        if (item.title?.includes('Big')) return false;
        return Array.isArray(item.collections) && item.collections.includes(conditionCollection);
      })
      .reduce((total, item) => total + item.quantity, 0);

    conditions.push({
      qtyNeeded: parseInt(promoData[`trigger_${i}_qty`], 10) || 1,
      upgradeQty:
        promoData.upgrade_enabled === false ? 0 : parseInt(promoData[`trigger_${i}_upgrade_qty`], 10) || 0,
      count,
    });
  }

  if (!conditions.length || conditions.some((condition) => condition.count < condition.qtyNeeded)) return 0;

  const allocationCondition = conditions.find((condition) => condition.upgradeQty > 0) || conditions[0];
  const baseThreshold = parseInt(allocationCondition.qtyNeeded, 10) || 1;
  const upgradeThreshold = parseInt(allocationCondition.upgradeQty, 10) || 0;
  const baseOnlyQty = parseInt(promoData.product_qty, 10) || 1;
  const fullCycleBaseQty = parseInt(promoData.promo_full_cycle_base_qty, 10) || baseOnlyQty;
  const count = allocationCondition.count;
  const upgradeConfigured = options.upgradeConfigured === true;
  const hasUpgradeThresholds = conditions.some((condition) => condition.upgradeQty > 0);
  const upgradeInStock = options.upgradeInStock !== false;

  let earnedQty = 0;

  if (upgradeConfigured && hasUpgradeThresholds) {
    if (count >= baseThreshold) {
      if (upgradeThreshold > 0) {
        const remainder = count % upgradeThreshold;
        if (remainder >= baseThreshold) earnedQty = fullCycleBaseQty;
      } else {
        earnedQty = Math.floor(count / baseThreshold) * baseOnlyQty;
      }
    }

    if (!upgradeInStock) {
      earnedQty = Math.floor(count / baseThreshold) * baseOnlyQty;
    }
  } else {
    earnedQty = Math.floor(count / baseThreshold) * baseOnlyQty;
  }

  const baseMaxQty = parseInt(promoData.product_max_qty, 10) || 0;
  if (baseMaxQty > 0) earnedQty = Math.min(earnedQty, baseMaxQty);

  return earnedQty;
}

function attachCartItemCollections(cart) {
  let attachedCount = 0;

  (cart?.items || []).forEach((item) => {
    const onPageItem = document.querySelector('.cart-item-' + String(item.key).replace(':', '-'));
    if (!onPageItem?.dataset?.collections) return;

    try {
      item.collections = JSON.parse(onPageItem.dataset.collections);
      attachedCount += 1;
    } catch (error) {
      item.collections = [];
    }
  });

  return attachedCount;
}

function parseUnavailableRewardLines(drawer) {
  try {
    const data = JSON.parse(drawer?.dataset.unavailableRewardLines || '{"keys":[],"variant_ids":[]}');
    return {
      keys: Array.isArray(data.keys) ? data.keys.filter(Boolean) : [],
      variantIds: Array.isArray(data.variant_ids) ? data.variant_ids.map(String) : [],
    };
  } catch (error) {
    return { keys: [], variantIds: [] };
  }
}

function rewardCollectionHandles() {
  const handles = new Set();

  document.querySelectorAll('promotional-drawer[data-promotional-reward="base"]').forEach((drawer) => {
    try {
      const data = JSON.parse(drawer.dataset.data || '{}');
      const collection = data.product_collection;
      const handle = typeof collection === 'string' ? collection : collection?.handle;
      if (handle) handles.add(handle);
    } catch (error) {
      /* settings JSON can be empty while the drawer is connecting */
    }
  });

  return handles;
}

function rowMatchesReward(row) {
  if (row.dataset.isPromotionalItem === 'true') return true;

  let collections = [];
  try {
    collections = JSON.parse(row.dataset.collections || '[]');
  } catch (error) {
    collections = [];
  }

  const handles = rewardCollectionHandles();
  return collections.some((handle) => handles.has(handle));
}

function unavailableRewardVariantIds() {
  const ids = new Set();

  document.querySelectorAll('promotional-drawer[data-promotional-reward="base"]').forEach((drawer) => {
    parseUnavailableRewardLines(drawer).variantIds.forEach((id) => ids.add(String(id)));
  });

  document.querySelectorAll('[data-line-key][data-variant-available="false"][data-variant-id]').forEach((row) => {
    if (!rowMatchesReward(row)) return;
    ids.add(String(row.dataset.variantId));
  });

  return ids;
}

function collectUnavailableRewardLines() {
  const lines = new Map();

  document.querySelectorAll('promotional-drawer[data-promotional-reward="base"]').forEach((drawer) => {
    const parsed = parseUnavailableRewardLines(drawer);
    parsed.keys.forEach((key, index) => {
      lines.set(key, {
        key,
        variantId: parsed.variantIds[index] || null,
      });
    });
  });

  document.querySelectorAll('[data-line-key][data-variant-available="false"]').forEach((row) => {
    if (!rowMatchesReward(row) || !row.dataset.lineKey) return;
    const existing = lines.get(row.dataset.lineKey) || {};
    lines.set(row.dataset.lineKey, {
      key: row.dataset.lineKey,
      variantId: row.dataset.variantId || existing.variantId || null,
      line: parseInt(row.dataset.lineIndex, 10) || null,
    });
  });

  return [...lines.values()];
}

async function postCart(url, body, type = 'json') {
  const response = await fetch(url, {
    ...fetchConfig(type),
    body: JSON.stringify(body),
  });
  const text = await response.text();

  try {
    return JSON.parse(text);
  } catch (error) {
    return { status: response.status || 422, message: text };
  }
}

function cartChangeSucceeded(parsed, key) {
  if (!parsed || parsed.status) {
    const description = `${parsed?.description || ''} ${parsed?.message || ''}`.toLowerCase();
    return description.includes('not found') || description.includes('cannot find');
  }

  if (key && Array.isArray(parsed.items)) {
    return !parsed.items.some((item) => item.key === key);
  }

  return true;
}

async function changeCartLineQuantity(line) {
  const byKey = await postCart(routes.cart_change_url, { id: line.key, quantity: 0 });
  if (cartChangeSucceeded(byKey, line.key)) return byKey;

  const cart = await fetch('/cart.js').then((response) => response.json());
  const index = (cart.items || []).findIndex((item) => item.key === line.key);
  if (index === -1) return cart;

  const byLine = await postCart(routes.cart_change_url, { line: index + 1, quantity: 0 });
  if (cartChangeSucceeded(byLine, line.key)) return byLine;

  if (line.variantId) {
    const byVariant = await postCart(routes.cart_update_url, { updates: { [line.variantId]: 0 } });
    if (cartChangeSucceeded(byVariant, line.key)) return byVariant;
    return byVariant;
  }

  return byLine;
}

async function refreshCartDrawerSurfaces(parsedState) {
  let htmlText = parsedState?.sections?.['cart-drawer'];

  try {
    const root = (routes.cart_url || '/cart').replace(/cart\/?$/, '');
    const response = await fetch(`${root}?sections=cart-drawer,cart-icon-bubble`);
    const sections = await response.json();
    htmlText = sections['cart-drawer'] || htmlText;
    parsedState = { ...(parsedState || {}), sections: { ...(parsedState?.sections || {}), ...sections } };
  } catch (error) {
    console.error(error);
  }

  if (htmlText) {
    const html = new DOMParser().parseFromString(htmlText, 'text/html');
    ['cart-drawer-items', '.cart-drawer__footer'].forEach((selector) => {
      const target = document.querySelector(selector);
      const source = html.querySelector(selector);
      if (target && source) target.replaceWith(source);
    });

    html.querySelectorAll('[id^="PromotionDrawerFooter-"]').forEach((source) => {
      const target = document.getElementById(source.id);
      if (target) target.innerHTML = source.innerHTML;
    });

    const iconSource = parsedState?.sections?.['cart-icon-bubble'];
    const icon = document.getElementById('cart-icon-bubble');
    if (icon && iconSource) {
      const nextIcon = new DOMParser().parseFromString(iconSource, 'text/html').getElementById('cart-icon-bubble');
      if (nextIcon) icon.innerHTML = nextIcon.innerHTML;
    }
  }

  const mainCart = document.getElementById('main-cart-items');
  if (mainCart?.dataset.id) {
    const response = await fetch(`${routes.cart_url}?section_id=${mainCart.dataset.id}`);
    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');
    const source = html.querySelector('#main-cart-items .js-contents');
    const target = mainCart.querySelector('.js-contents');
    if (target && source) target.innerHTML = source.innerHTML;
  }

  document.querySelectorAll('promotional-drawer').forEach((drawer) => {
    drawer.setDrawerOpeningLinks?.();
    drawer.applyEarnedQuantityMax?.();
  });

  return parsedState;
}

let unavailableRewardRemoval = null;

async function removeUnavailablePromotionalLines() {
  if (unavailableRewardRemoval) return unavailableRewardRemoval;

  unavailableRewardRemoval = removeUnavailablePromotionalLinesNow().finally(() => {
    unavailableRewardRemoval = null;
  });

  return unavailableRewardRemoval;
}

async function removeUnavailablePromotionalLinesNow() {
  const lines = collectUnavailableRewardLines();
  if (!lines.length) return null;

  let lastState = null;
  let removed = false;

  for (const line of lines) {
    const parsed = await changeCartLineQuantity(line);
    if (cartChangeSucceeded(parsed, line.key)) {
      removed = true;
      lastState = parsed;
    }
  }

  if (!removed) return lastState;

  const removedVariantIds = lines.map((line) => line.variantId).filter(Boolean).map(String);
  document.querySelectorAll('promotional-drawer[data-unavailable-reward-lines]').forEach((drawer) => {
    const variantIds = [...new Set([...parseUnavailableRewardLines(drawer).variantIds, ...removedVariantIds])];
    drawer.dataset.unavailableRewardLines = JSON.stringify({ keys: [], variant_ids: variantIds });
  });

  return refreshCartDrawerSurfaces(lastState);
}

function ignoreUnavailableRewardInputs() {
  const blocked = unavailableRewardVariantIds();
  if (!blocked.size) return;

  document.querySelectorAll('promotional-drawer input[data-quantity-variant-id]').forEach((input) => {
    if (!blocked.has(String(input.dataset.quantityVariantId))) return;
    input.value = '0';
    input.closest('quantity-input')?.validateQtyRules?.();
  });
}

function omitUnavailableRewardVariants(items) {
  const blocked = unavailableRewardVariantIds();
  if (!blocked.size || !items) return items;

  const next = { ...items };
  Object.keys(next).forEach((id) => {
    if (blocked.has(String(id))) delete next[id];
  });
  return next;
}

async function releaseUnconfirmedRewardInputs(items) {
  const cart = await fetch('/cart.js').then((response) => response.json());
  const quantities = new Map();

  (cart.items || []).forEach((item) => {
    const id = String(item.variant_id || item.id);
    quantities.set(id, (quantities.get(id) || 0) + item.quantity);
  });

  Object.keys(items || {}).forEach((id) => {
    const input = document.querySelector(`promotional-drawer input[data-quantity-variant-id="${id}"]`);
    if (!input) return;
    const inCart = quantities.get(String(id)) || 0;
    if ((parseInt(input.value, 10) || 0) === inCart) return;
    input.value = String(inCart);
    input.closest('quantity-input')?.validateQtyRules?.();
  });

  document.querySelectorAll('promotional-drawer').forEach((drawer) => drawer.applyEarnedQuantityMax?.());
}

function clampRewardItemsToEarned(items) {
  const drawer = document.querySelector('promotional-drawer[data-reward-limit="earned"]');
  if (!drawer || !items) return items;

  const earned = parseInt(drawer.dataset.earnedQty, 10);
  if (!Number.isFinite(earned)) return items;

  const quantities = new Map();
  const blocked = unavailableRewardVariantIds();
  drawer.querySelectorAll('input[data-quantity-variant-id]').forEach((input) => {
    if (input.closest('[data-variant-available="false"]')) return;
    if (blocked.has(String(input.dataset.quantityVariantId))) return;
    quantities.set(String(input.dataset.quantityVariantId), parseInt(input.value, 10) || 0);
  });

  Object.entries(items).forEach(([id, quantity]) => {
    quantities.set(String(id), parseInt(quantity, 10) || 0);
  });

  let total = 0;
  quantities.forEach((quantity) => {
    total += quantity;
  });
  if (total <= earned) return items;

  const clamped = { ...items };
  let overflow = total - earned;

  Object.keys(clamped).forEach((id) => {
    if (overflow <= 0) return;
    const current = parseInt(clamped[id], 10) || 0;
    const next = Math.max(0, current - overflow);
    overflow -= current - next;
    clamped[id] = next;
  });

  return clamped;
}

async function postPromotionalRewardQuantities(items, sections, sectionsUrl) {
  const cart = await fetch('/cart.js').then((response) => response.json());
  const updates = {};
  const itemsToAdd = [];

  Object.entries(items).forEach(([variantId, quantity]) => {
    const id = parseInt(variantId, 10);
    const targetQty = parseInt(quantity, 10) || 0;
    const lines = cart.items.filter((item) => item.variant_id === id || item.id === id);
    const promoLine = lines.find((item) => lineHasPromotionalProperty(item));
    const plainLines = lines.filter((item) => !lineHasPromotionalProperty(item));

    plainLines.forEach((line) => {
      updates[line.key] = 0;
    });

    if (promoLine) {
      if (promoLine.quantity !== targetQty) updates[promoLine.key] = targetQty;
    } else if (targetQty > 0) {
      itemsToAdd.push({
        id,
        quantity: targetQty,
        properties: promotionalItemProperties(),
      });
    }
  });

  let parsedState = null;

  if (itemsToAdd.length > 0) {
    const addedState = await postCart(
      routes.cart_add_url,
      {
        items: itemsToAdd,
        sections,
        sections_url: sectionsUrl,
      },
      'javascript'
    );
    if (addedState.status) {
      throw new Error(addedState.description || addedState.message || 'Unable to add promotional item');
    }
    parsedState = addedState;
  }

  if (Object.keys(updates).length > 0) {
    parsedState = await postCart(routes.cart_update_url, {
      updates,
      sections,
      sections_url: sectionsUrl,
    });
    if (parsedState?.status) {
      throw new Error(parsedState.description || parsedState.message || 'Unable to update promotional item');
    }
  }

  return parsedState;
}

async function applyPromotionalRewardQuantities({ items, sections, sectionsUrl }) {
  await removeUnavailablePromotionalLines();
  ignoreUnavailableRewardInputs();
  items = omitUnavailableRewardVariants(items);
  items = clampRewardItemsToEarned(items);

  let parsedState = null;

  try {
    parsedState = await postPromotionalRewardQuantities(items, sections, sectionsUrl);
  } catch (error) {
    await removeUnavailablePromotionalLines();
    ignoreUnavailableRewardInputs();
    try {
      parsedState = await postPromotionalRewardQuantities(items, sections, sectionsUrl);
    } catch (retryError) {
      await releaseUnconfirmedRewardInputs(items);
      throw retryError;
    }
  }

  if (parsedState) {
    parsedState = await refreshCartDrawerSurfaces(parsedState);
  }

  return parsedState;
}

class MasterPromotion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (typeof subscribe !== 'function') return;

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.internal || event?.source === 'master-promotion') return;
      this.queuePromoUpdate(event?.cartData);
    });

    this.scheduleConnectSync();
  }

  scheduleConnectSync() {
    if (this._connectSyncScheduled) return;
    this._connectSyncScheduled = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this._connectSyncScheduled = false;
        if (Date.now() < promoConnectSyncSuppressedUntil) return;
        this.queuePromoUpdate();
      });
    });
  }

  queuePromoUpdate(cartData) {
    const run = () => {
      if (typeof PromoCartSync?.enqueuePromo === 'function') {
        PromoCartSync.enqueuePromo(() => this.updatePromoItems());
        return;
      }

      this.updatePromoItems();
    };

    if (this._promoUpdateCoalesceTimer) {
      clearTimeout(this._promoUpdateCoalesceTimer);
    }

    this._promoUpdateCoalesceTimer = setTimeout(() => {
      this._promoUpdateCoalesceTimer = null;
      run();
    }, 50);
  }

  disconnectedCallback() {
    if (this._promoUpdateCoalesceTimer) {
      clearTimeout(this._promoUpdateCoalesceTimer);
      this._promoUpdateCoalesceTimer = null;
    }

    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  getPromoData() {
    return JSON.parse(this.dataset.data || '{}');
  }

  getAutoAddProducts(promoData) {
    try {
      const fallbackProducts = JSON.parse(this.dataset.autoAddProducts || '[]');
      if (Array.isArray(fallbackProducts) && fallbackProducts.length > 0) {
        return fallbackProducts;
      }
    } catch (error) {
      /* fall through */
    }

    if (Array.isArray(promoData.product_list) && promoData.product_list.length > 0) {
      return promoData.product_list;
    }

    return [];
  }

  getUpgradeProducts(promoData) {
    try {
      const fallbackProducts = JSON.parse(this.dataset.upgradeProducts || '[]');
      if (Array.isArray(fallbackProducts) && fallbackProducts.length > 0) {
        return fallbackProducts;
      }
    } catch (error) {
      /* fall through */
    }

    if (Array.isArray(promoData.upgrade_product_list) && promoData.upgrade_product_list.length > 0) {
      return promoData.upgrade_product_list;
    }

    return [];
  }

  async getCart() {
    return fetch('/cart.js').then((response) => response.json());
  }

  isPromoLineItem(item, promoData) {
    if (item.properties?._promotional_item) return true;

    const variantId = item.variant_id || item.id;
    const rewardProducts = [...this.getAutoAddProducts(promoData), ...this.getUpgradeProducts(promoData)];

    return rewardProducts.some((product) => product.variants?.some((variant) => variant.id === variantId));
  }

  attachCollectionData(cart) {
    let attachedCount = 0;

    cart.items.forEach((item) => {
      if (this.isPromoLineItem(item, this.getPromoData())) {
        item.collections = [];
        return;
      }

      const onPageItem = document.querySelector('.cart-item-' + item.key.replace(':', '-'));
      if (!onPageItem) return;

      const collections = onPageItem.dataset.collections;
      if (!collections) return;

      try {
        item.collections = JSON.parse(collections);
        attachedCount += 1;
      } catch (error) {
        item.collections = [];
      }
    });

    return attachedCount;
  }

  getFirstAvailableProduct(productList) {
    if (!productList?.length) return null;

    return (
      productList.find((product) => product.variants?.some((variant) => variant.available)) ||
      productList[0]
    );
  }

  isUpgradeProductAvailable(productList) {
    if (!productList?.length) return false;

    return productList.some((product) => {
      const availableVariant = product.variants?.find((variant) => variant.available);
      if (!availableVariant) return false;
      return getCookie('deny_promo_' + availableVariant.id) !== 'true';
    });
  }

  isRestricted(promoData) {
    return this.dataset.restrictedActive === '1';
  }

  buildConditions(promoData, cart) {
    const conditions = [];

    for (let i = 1; i <= 3; i++) {
      if (promoData[`trigger_${i}_enabled`] === false) continue;

      const conditionCollection = promoData[`trigger_${i}_collection`];
      if (!conditionCollection) continue;

      const conditionItemsInCart = cart.items
        .filter(
          (item) =>
            !item.properties?._promotional_item &&
            Array.isArray(item.collections) &&
            item.collections.includes(conditionCollection) &&
            !item.title.includes('Big')
        )
        .reduce((total, item) => total + item.quantity, 0);

      conditions.push({
        index: i,
        collection: conditionCollection,
        qtyNeeded: promoData[`trigger_${i}_qty`],
        upgradeQty: promoData.upgrade_enabled === false ? 0 : promoData[`trigger_${i}_upgrade_qty`] || 0,
        count: conditionItemsInCart,
      });
    }

    return conditions;
  }

  isUpgradeConfigured(promoData) {
    if (promoData.upgrade_enabled === false) return false;

    const upgradeProducts = this.getUpgradeProducts(promoData);
    if (upgradeProducts.length > 0) return true;

    return (
      Array.isArray(promoData.upgrade_product_list) && promoData.upgrade_product_list.length > 0
    );
  }

  calculateCycleBasePromoCount(count, baseThreshold, upgradeThreshold, baseOnlyQty, fullCycleBaseQty, fullCycleSize) {
    if (count < baseThreshold) return 0;

    // When no upgrade threshold is configured, fall back to simple base spacing.
    if (!upgradeThreshold || upgradeThreshold <= 0) {
      return Math.floor(count / baseThreshold) * baseOnlyQty;
    }

    // Base kits are earned inside each upgrade-sized window, not accumulated per
    // completed full cycle. With base=3 and upgrade=5:
    //   remainders 3–4 → 1 col-kit (e.g. 3–4, 8–9, 13–14, 18–19, 23–24)
    //   remainders 0–2 → upgrade-only / no base (e.g. 5–7, 10–12, 15–17, 20–22, 25)
    // fullCycleSize is retained for callers/settings compatibility but base placement
    // is driven by upgradeThreshold so 15–25 match the Halloween kit schedule.
    const rem = count % upgradeThreshold;
    if (rem >= baseThreshold) {
      return fullCycleBaseQty || baseOnlyQty;
    }

    return 0;
  }

  calculatePromoCounts(promoData, conditions) {
    let basePromoCount = 0;
    let upgradePromoCount = 0;

    const allConditionsMet = conditions.every((condition) => condition.count >= condition.qtyNeeded);
    if (!allConditionsMet) {
      return { basePromoCount, upgradePromoCount };
    }

    const upgradeCondition = conditions.find((condition) => condition.upgradeQty > 0);
    const allocationCondition = upgradeCondition || conditions[0];
    const baseThreshold = parseInt(allocationCondition.qtyNeeded, 10) || 1;
    const upgradeThreshold = parseInt(allocationCondition.upgradeQty, 10) || 0;
    const baseOnlyQty = parseInt(promoData.product_qty, 10) || 1;
    const upgradeOnlyQty = parseInt(promoData.upgrade_product_qty, 10) || 1;
    const fullCycleBaseQty = parseInt(promoData.promo_full_cycle_base_qty, 10) || baseOnlyQty;
    const count = allocationCondition.count;

    const upgradeProducts = this.getUpgradeProducts(promoData);
    const upgradeConfigured = this.isUpgradeConfigured(promoData);
    const hasUpgradeThresholds = conditions.some((condition) => condition.upgradeQty > 0);
    const upgradeStockAvailable =
      upgradeProducts.length > 0 && this.isUpgradeProductAvailable(upgradeProducts);
    const configuredFullCycle = parseInt(promoData.promo_full_cycle_qty, 10);
    const fullCycleSize =
      configuredFullCycle ||
      upgradeThreshold + baseThreshold + Math.max(0, upgradeThreshold - baseThreshold);

    if (upgradeConfigured && hasUpgradeThresholds) {
      // Always use the cycle table for base rewards when an upgrade tier exists.
      // The simple floor(count / 3) fallback is only for confirmed sold-out upgrades.
      basePromoCount = this.calculateCycleBasePromoCount(
        count,
        baseThreshold,
        upgradeThreshold,
        baseOnlyQty,
        fullCycleBaseQty,
        fullCycleSize
      );

      if (upgradeStockAvailable && count >= upgradeThreshold) {
        upgradePromoCount = Math.floor(count / upgradeThreshold) * upgradeOnlyQty;
      } else if (!upgradeStockAvailable && upgradeProducts.length > 0) {
        basePromoCount = Math.floor(count / baseThreshold) * baseOnlyQty;
        upgradePromoCount = 0;
      }
    } else {
      basePromoCount = Math.floor(count / baseThreshold) * baseOnlyQty;
    }

    const baseMaxQty = parseInt(promoData.product_max_qty, 10) || 0;
    if (baseMaxQty > 0) {
      basePromoCount = Math.min(basePromoCount, baseMaxQty);
    }

    const upgradeMaxQty = parseInt(promoData.upgrade_max_qty, 10) || 0;
    if (upgradeMaxQty > 0) {
      upgradePromoCount = Math.min(upgradePromoCount, upgradeMaxQty);
    }

    return { basePromoCount, upgradePromoCount };
  }

  getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'CartDrawer',
        selector: '.drawer__inner',
        section: 'cart-drawer',
      },
    ];

    if (window.request?.page_type === 'cart') {
      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems?.dataset.id) {
        sections.push({
          id: 'main-cart-items',
          section: mainCartItems.dataset.id,
          selector: '.js-contents',
        });
      }

      sections.push({
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      });
    }

    document.querySelectorAll('promotional-drawer').forEach((drawer) => {
      sections.push({
        id: 'PromotionHolder',
        section: 'cart-drawer',
        selector: '#PromotionDrawerFooter-' + drawer.dataset.promoId,
      });
    });

    return sections;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(lines = []) {
    const mainCartItems =
      document.getElementById('CartDrawer-CartItems') || document.getElementById('main-cart-items');
    mainCartItems?.classList.add('cart__items--disabled');

    lines.forEach((line) => {
      const cartItemElements = document.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = document.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    });
  }

  disableLoading(lines = []) {
    lines.forEach((line) => {
      const cartItemElements = document.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = document.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    });

    document.querySelectorAll('cart-drawer-items .loading__spinner, cart-items .loading__spinner').forEach((overlay) => {
      overlay.classList.add('hidden');
    });

    if (PromoCartSync?.isLocked()) return;

    const mainCartItems =
      document.getElementById('CartDrawer-CartItems') || document.getElementById('main-cart-items');
    mainCartItems?.classList.remove('cart__items--disabled');
  }

  runPostSyncTasks() {
    setTimeout(() => {
      document.querySelectorAll('promotional-drawer').forEach((drawer) => drawer.setDrawerOpeningLinks());
    });
  }

  renderUpdatedSections(parsedState) {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartItemsElement = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');

    cartItemsElement?.classList.toggle('is-empty', parsedState.item_count === 0);
    cartDrawerWrapper?.classList.toggle('is-empty', parsedState.item_count === 0);

    if (window.request?.page_type === 'cart') {
      document.getElementById('main-cart-items')?.classList.toggle('is-empty', parsedState.item_count === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement || !parsedState.sections?.[section.section]) return;

      const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );

      if (typeof logCartDomReplace === 'function') {
        logCartDomReplace('promo-auto-add:renderUpdatedSections', section.selector || section.id);
      }
    });
  }

  addItems(items, options = {}) {
    const { render = true, publish = true, includeSections = true } = options;
    const cart = this.getCartDrawer();
    if (!cart) return Promise.resolve(null);

    const payload = { items };

    if (includeSections) {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }

    const body = JSON.stringify(payload);

    return fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'master-promotion',
            productVariantId: items[0].id,
            errors: response.errors || response.description,
            message: response.message,
          });
          return null;
        }

        if (publish) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'master-promotion',
            productVariantId: items[0].id,
            cartData: response,
          });
        }

        if (render) {
          cart.renderContents(response);
        }

        return response;
      })
      .catch((error) => {
        console.error(error);
        return null;
      });
  }

  updateMultipleQty(items, lines, options = {}) {
    const { render = true, publish = true, includeSections = true } = options;
    const cart = this.getCartDrawer();
    if (!cart) return Promise.resolve(null);

    const payload = { updates: items };

    if (includeSections) {
      payload.sections = this.getSectionsToRender().map((section) => section.section);
      payload.sections_url = window.location.pathname;
    }

    const body = JSON.stringify(payload);

    return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (publish) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'master-promotion',
            cartData: parsedState,
          });
        }

        if (render) {
          this.renderUpdatedSections(parsedState);
        }

        return parsedState;
      })
      .catch((error) => {
        console.error(error);
        cart.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
        return null;
      })
      .finally(() => {
        if (render) {
          this.runPostSyncTasks();
          this.disableLoading(lines);
        }
      });
  }

  buildPromoSyncPlan(promoData, cart) {
    const nonPromoLineItems = cart.items.filter((item) => !this.isPromoLineItem(item, promoData));
    const attachedCount = this.attachCollectionData(cart);

    if (nonPromoLineItems.length > 0 && attachedCount < nonPromoLineItems.length) {
      return null;
    }

    const conditions = this.buildConditions(promoData, cart);
    if (!conditions.length) return null;

    const triggerCount = conditions.reduce((max, condition) => Math.max(max, condition.count), 0);

    if (triggerCount === 0 && nonPromoLineItems.length > 0) {
      return null;
    }

    const { basePromoCount, upgradePromoCount } = this.calculatePromoCounts(promoData, conditions);
    const itemsToUpdate = {};
    const itemsToAdd = [];
    const lines = [];

    if (promoData.payload_enabled !== false) {
      const baseProduct = this.getFirstAvailableProduct(this.getAutoAddProducts(promoData));
      if (baseProduct) {
        this.syncPromoProduct(baseProduct, basePromoCount, cart, itemsToUpdate, itemsToAdd, lines);
      }
    }

    if (promoData.upgrade_enabled !== false) {
      const upgradeProduct = this.getFirstAvailableProduct(this.getUpgradeProducts(promoData));
      if (upgradeProduct) {
        this.syncPromoProduct(upgradeProduct, upgradePromoCount, cart, itemsToUpdate, itemsToAdd, lines);
      }
    }

    return { itemsToUpdate, itemsToAdd, lines };
  }

  async applyPromoCartChanges(plan, promoData) {
    let itemsToUpdate = { ...plan.itemsToUpdate };
    let itemsToAdd = [...plan.itemsToAdd];
    let lines = [...plan.lines];
    const hasUpdates = Object.keys(itemsToUpdate).length > 0;
    const hasAdds = itemsToAdd.length > 0;

    if (!hasUpdates && !hasAdds) return null;

    suppressPromoConnectSync();

    this.enableLoading(lines);

    let parsedState = null;

    if (hasUpdates) {
      parsedState = await this.updateMultipleQty(itemsToUpdate, lines, {
        render: false,
        publish: false,
        includeSections: true,
      });
    }

    let didAddItems = false;

    if (hasAdds) {
      if (hasUpdates) {
        const cartAfterUpdates = parsedState?.items ? parsedState : await this.getCart();
        const recalculatedPlan = this.buildPromoSyncPlan(promoData, cartAfterUpdates);
        itemsToAdd = recalculatedPlan?.itemsToAdd || [];
        itemsToUpdate = recalculatedPlan?.itemsToUpdate || {};
        lines = recalculatedPlan?.lines || lines;

        if (Object.keys(itemsToUpdate).length > 0) {
          parsedState = await this.updateMultipleQty(itemsToUpdate, lines, {
            render: false,
            publish: false,
            includeSections: true,
          });
        }
      }

      if (itemsToAdd.length > 0) {
        parsedState = await this.addItems(itemsToAdd, {
          render: false,
          publish: false,
          includeSections: true,
        });
        didAddItems = true;
      }
    }

    if (!parsedState) return null;

    if (didAddItems && parsedState.sections) {
      this.getCartDrawer()?.renderContents(parsedState);
    } else {
      this.renderUpdatedSections(parsedState);
    }

    PromoCartSync?.refreshLockUI();

    this.runPostSyncTasks();
    this.disableLoading(lines);

    return parsedState;
  }

  syncPromoProduct(product, targetQty, cart, itemsToUpdate, itemsToAdd, lines) {
    if (!product?.variants?.length) return;

    const productVariantIds = product.variants.map((variant) => variant.id);
    const availableVariant = product.variants.find((variant) => variant.available);
    const matchingItems = cart.items.filter((item) => productVariantIds.includes(item.id));
    const promoCartItem = matchingItems.find((item) => lineHasPromotionalProperty(item)) || matchingItems[0];
    const promoCartItemIndex = promoCartItem
      ? cart.items.findIndex((item) => item.key === promoCartItem.key)
      : -1;
    const promoQtyInCart = promoCartItem ? promoCartItem.quantity : 0;

    if (promoCartItem && promoQtyInCart !== targetQty) {
      itemsToUpdate[promoCartItem.key] = targetQty;
      lines.push(promoCartItemIndex + 1);
      return;
    }

    if (!availableVariant || targetQty <= 0 || promoQtyInCart === targetQty) return;
    if (getCookie('deny_promo_' + availableVariant.id) === 'true') return;

    itemsToAdd.push({
      id: availableVariant.id,
      quantity: targetQty,
      properties: promotionalItemProperties(),
    });
  }

  rewardVariantIds(promoData) {
    const variantIds = new Set();

    [...this.getAutoAddProducts(promoData), ...this.getUpgradeProducts(promoData)].forEach((product) => {
      product.variants?.forEach((variant) => variantIds.add(variant.id));
    });

    return variantIds;
  }

  async ensurePromotionalProperties(cart, promoData, plan) {
    const rewardVariantIds = this.rewardVariantIds(promoData);
    const unstamped = cart.items.filter((item) => {
      if (!rewardVariantIds.has(item.id) || lineHasPromotionalProperty(item) || item.quantity <= 0) return false;

      const nextQty = plan?.itemsToUpdate?.[item.key];
      return nextQty !== 0 && nextQty !== '0';
    });

    if (!unstamped.length) return { cart, changed: false };

    const stampedVariantIds = new Set(
      cart.items.filter((item) => lineHasPromotionalProperty(item)).map((item) => item.id)
    );

    const itemsToAdd = unstamped
      .filter((item) => !stampedVariantIds.has(item.id) && getCookie('deny_promo_' + item.id) !== 'true')
      .map((item) => ({
        id: item.id,
        quantity: item.quantity,
        properties: promotionalItemProperties(),
      }));

    if (itemsToAdd.length > 0) {
      const addedState = await this.addItems(itemsToAdd, {
        render: false,
        publish: false,
        includeSections: false,
      });

      if (!addedState) return { cart, changed: false };
    }

    const updates = {};
    unstamped.forEach((item) => {
      if (getCookie('deny_promo_' + item.id) === 'true') return;
      updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) return { cart, changed: false };

    const parsedState = await this.updateMultipleQty(updates, [], {
      render: false,
      publish: false,
      includeSections: true,
    });

    if (!parsedState?.items) return { cart, changed: false };

    return { cart: parsedState, changed: true, parsedState };
  }

  async updatePromoItems() {
    const promoData = this.getPromoData();

    if (promoData.promotion_presentation_type !== 'auto_add') return;
    if (this.isRestricted(promoData)) return;

    try {
      const cart = await this.getCart();
      if (!cart?.items?.length) return;

      let plan = this.buildPromoSyncPlan(promoData, cart);
      if (!plan) return;

      const stamped = await this.ensurePromotionalProperties(cart, promoData, plan);
      if (stamped.changed) {
        plan = this.buildPromoSyncPlan(promoData, stamped.cart);
        if (!plan) {
          if (stamped.parsedState) {
            this.renderUpdatedSections(stamped.parsedState);
            this.runPostSyncTasks();
          }
          return;
        }
      }

      const hasChanges = plan.itemsToAdd.length > 0 || Object.keys(plan.itemsToUpdate).length > 0;

      if (hasChanges) {
        await this.applyPromoCartChanges(plan, promoData);
      } else if (stamped.changed && stamped.parsedState) {
        this.renderUpdatedSections(stamped.parsedState);
        this.runPostSyncTasks();
      } else if (typeof scheduleRefreshStrikethrough === 'function') {
        scheduleRefreshStrikethrough('master-promotion:updatePromoItems-no-change');
      }
    } catch (error) {
      console.error(error);
    }
  }
}

if (!customElements.get('master-promotion')) {
  customElements.define('master-promotion', MasterPromotion);
}

function rebindPromotionalDrawers() {
  document.querySelectorAll('promotional-drawer').forEach((drawer) => {
    drawer.setDrawerOpeningLinks?.();
    drawer.applyEarnedQuantityMax?.();
  });
}

function bootUnavailableRewardRecovery() {
  rebindPromotionalDrawers();
  removeUnavailablePromotionalLines();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootUnavailableRewardRecovery);
} else {
  bootUnavailableRewardRecovery();
}

let releasingUnavailableRewardCheckout = false;

document.addEventListener(
  'click',
  (event) => {
    if (releasingUnavailableRewardCheckout) return;

    const button = event.target.closest('.cart__checkout-button');
    if (!button || button.hasAttribute('disabled')) return;
    if (!collectUnavailableRewardLines().length) return;

    event.preventDefault();
    event.stopPropagation();

    removeUnavailablePromotionalLines().finally(() => {
      const blockedNext = document.querySelector(
        'promotional-drawer[data-promotional-reward="base"] button.drawer__footer_button[disabled]'
      );

      if (blockedNext) {
        document.querySelector('cart-drawer')?.close();
        blockedNext.closest('promotional-drawer')?.open();
        return;
      }

      releasingUnavailableRewardCheckout = true;
      button.click();
      releasingUnavailableRewardCheckout = false;
    });
  },
  true
);
